var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { APP_ROUTES, useAppDispatch, useAppNavigate, useAppSelector } from '@core';
import { ACCOUNT_FETCH_ROUTES } from '@features/account/constants';
import { logout } from '@features/account/services';
import { useEffect } from 'react';
import { ImExit } from 'react-icons/im';
export var LogoutHeader = function () {
    var dispatch = useAppDispatch();
    var navigate = useAppNavigate();
    var userData = useAppSelector(function (store) { return store.userData; });
    useEffect(function () {
        var _a;
        if (((_a = userData.fetch_data) === null || _a === void 0 ? void 0 : _a.fetch_name) === ACCOUNT_FETCH_ROUTES.logout.fetch_name) {
            navigate(APP_ROUTES.landing.route);
        }
    }, [userData.fetch_data]);
    var logoutHandler = function () {
        dispatch(logout());
    };
    return (_jsx("div", __assign({ className: "flex flex-row items-center gap-[21px]" }, { children: userData.data ? (_jsxs(_Fragment, { children: [_jsx("p", __assign({ className: "text-sm font-normal leading-5 tracking-tight text-[#14181F]" }, { children: userData.data.companyName })), _jsx("div", __assign({ className: "relative size-[32px] cursor-pointer rounded-lg border border-solid border-[#EDEFF2]", onClick: logoutHandler }, { children: _jsx(ImExit, { className: "absolute left-[6px] top-[6px] size-[20px]" }) }))] })) : (_jsx(_Fragment, {})) })));
};
